import React, { useState } from 'react';
import {
  Button, Form, Row, Col,
} from 'react-bootstrap';
import '../style/style.css';
import axios from 'axios';
import SuccessMessage from './SuccessMessage';

export default function EmailValidation() {
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [rePassword, setRePassword] = useState();
  const [show, setShow] = useState(false);
  const [errorMsg, setError] = useState('');

  const reset = async (e) => {
    e.preventDefault();
    document.getElementById('password-edit').reset();
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const request = { oldPassword, newPassword, rePassword };
      await axios.post(
        `${
          process.env.REACT_APP_API_URI
        }/api/update_password/${localStorage.getItem('auth-token')}`,
        request,
      );
      reset(e);
      setError(null);
      setShow(false);
      setShow(true);
    } catch (err) {
      setError(err.response.data.message);
    }
  };

  return (
    <div className="password-edit" id="editar-password">
      <Form id="password-edit" action="" method="post" onSubmit={submit}>
        <Form.Group className="mb-3">
          <Form.Label className="title mb-1">Alterar Palavra-Passe</Form.Label>
          <hr className="edit-divider" />
          <div className="edit-card-pad pass-edit-body">
            <Row className="d-flex align-items-center">
              <Form.Label column sm={3} className="card-label">
                {' '}
                Palavra-Passe Atual
              </Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="password"
                  id="current-password"
                  rows={1}
                  style={{ resize: 'none' }}
                  placeholder="Escreva a palavra-passe atual"
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="d-flex align-items-center">
              <Form.Label column sm={3} className="card-label">
                {' '}
                Nova Palavra-Passe
                {' '}
              </Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="password"
                  id="new-password"
                  rows={1}
                  style={{ resize: 'none' }}
                  placeholder="Escreva a nova palavra-passe"
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="d-flex align-items-center">
              <Form.Label column sm={3} className="card-label">
                {' '}
                Confirmar Palavra-Passe
                {' '}
              </Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="password"
                  id="confirm-new-password"
                  rows={1}
                  style={{ resize: 'none' }}
                  placeholder="Escreva novamente a nova palavra-passe"
                  onChange={(e) => setRePassword(e.target.value)}
                />
              </Col>
              <div>
                <small className="text-danger pre-wrap">{errorMsg}</small>
              </div>
            </Row>
            <div className="d-flex justify-content-md-start justify-content-center">
              <Button type="submit" variant="principal btn-custom">
                Guardar alterações
              </Button>
              <Button onClick={(e) => reset(e)} variant="cancel btn-custom">
                Cancelar
              </Button>
            </div>
          </div>
        </Form.Group>
      </Form>
      <SuccessMessage
        show={show}
        setShow={setShow}
        message="A palavra passe foi atualizada com sucesso!"
      />
    </div>
  );
}
